// extracted by mini-css-extract-plugin
export var content = "_ck-3";
export var list = "_ck-4";
export var settingsContent = "_ck-7";
export var settingsPanel = "_ck-8";
export var state = "_ck-6";
export var triggerBadge = "_ck-2";
export var triggerButton = "_ck-1";
export var triggerShell = "_ck-0";
export var unreadDot = "_ck-5";